<template>
  <template v-if="params.type === 'floatingFilter'">
    <FormattedTotal
      v-if="formattedTotal"
      :formattedTotal="formattedTotal"
    />
  </template>
  <template v-else-if="params.type === 'header'">
    <div
      class="ag-cell-label-container"
      role="presentation"
    >
      <FormattedTotal
        v-if="formattedTotal"
        :formattedTotal="formattedTotal"
      />
      <div
        ref="eLabel"
        class="ag-header-cell-label"
        role="presentation"
      >
        <span
          ref="eText"
          class="ag-header-cell-text"
        >
          {{ params.column.colDef.headerName }}
        </span>
      </div>
    </div>
  </template>
</template>

<script setup>
import { defineProps, defineComponent, onBeforeUnmount, onMounted, ref, computed } from 'vue'
import { USD, calculateTotalCents } from '@/utils/currency'
import { ReceiptTextIcon } from 'lucide-vue-next'

const props = defineProps({
  params: Object
})

const FormattedTotal = defineComponent({
  name: 'FormattedTotal',
  props: ['formattedTotal'],
  template: `
  <span
    class="flex items-center gap-1 py-1 text-xs"
  >
    <ReceiptTextIcon
      stroke-width="1.5"
      size="14"
    />
    {{ formattedTotal }}
  </span>
  `,
  components: { ReceiptTextIcon }
})

let rowValues = ref([])

const onDataChanged = () => {
  rowValues.value = []

  const rowCount = props.params.api.getDisplayedRowCount()

  for (let i = 0; i < rowCount; i++) {
    const rowNode = props.params.api.getDisplayedRowAtIndex(i)
    if (rowNode.stub) continue
    rowValues.value.push(rowNode.data[props.params.column.colId])
  }
}

const totalCents = computed(() => calculateTotalCents(rowValues.value))

const formattedTotal = computed(() => {
  return totalCents.value === 0 ? '' : USD.format(totalCents.value / 100)
})

props.params.api.addEventListener('displayedRowsChanged', onDataChanged)

onMounted(() => {
  onDataChanged()
})

onBeforeUnmount(() => {
  props.params.api.removeEventListener('displayedRowsChanged', onDataChanged)
})
</script>
